import {useEffect,useRef,useState} from "react";
import axios from "axios";
import {API_URL} from "../../../../config";
import {readHistoryResponse} from "./rsoHistoryHelpers";

const empty = {items:[],nextCursor:null,status:"idle"};
export const useRsoHistory = ({enabled,token,contactInfoId,forecastMonth,reloadKey}) => {
  const key = enabled && token && Number.isInteger(contactInfoId) && contactInfoId > 0
    ? JSON.stringify([token,contactInfoId,forecastMonth,reloadKey]) : "";
  const [result,setResult] = useState({...empty,key:""});
  const [request,setRequest] = useState({key:"",cursor:null,attempt:0});
  const currentKey = useRef(key);
  currentKey.current = key;
  const cursor = request.key === key ? request.cursor : null;
  useEffect(() => {
    if (!key) {
      setResult({...empty,key:""});
      setRequest((old) => old.key ? {key:"",cursor:null,attempt:old.attempt} : old);
      return undefined;
    }
    const controller = new AbortController();
    let current = true;
    setResult((old) => ({...(old.key === key && cursor ? old : empty),key,status:"loading"}));
    axios.get(`${API_URL}/Dashboard/api/Dashboard/RsoSalesForecastHistory`,{
      headers:{Authorization:`Bearer ${token}`},params:{contactInfoId,...(forecastMonth ? {forecastMonth} : {}),...(cursor ? {cursor} : {})},
      signal:controller.signal,timeout:15000,
    }).then((response) => {
      const page = readHistoryResponse(response.data,contactInfoId,forecastMonth);
      if (!current || controller.signal.aborted || currentKey.current !== key) return;
      setResult((old) => {
        const previous = cursor && old.key === key ? old.items : [];
        const ids = new Set(previous.map((row) => row.id));
        return {key,status:"ready",items:[...previous,...page.items.filter((row) => !ids.has(row.id))],
          nextCursor:page.nextCursor === cursor ? null : page.nextCursor};
      });
    }).catch((error) => {
      if (!current || controller.signal.aborted || currentKey.current !== key) return;
      setResult((old) => ({...(old.key === key && ![401,403].includes(error?.response?.status) ? old : empty),key,status:"error"}));
    });
    return () => {current=false;controller.abort();};
  },[key,token,contactInfoId,forecastMonth,cursor,request.attempt]);
  const visible = !key ? empty : result.key === key ? result : {...empty,status:"loading"};
  return {...visible,loadMore:() => {
    if (visible.status === "ready" && visible.nextCursor) setRequest({key,cursor:visible.nextCursor,attempt:request.attempt+1});
  },retry:() => setRequest({key,cursor,attempt:request.attempt+1})};
};
